import React from "react";
import { ReactComponent as BusIcon } from "../../../../assets/icons/Bus.svg";
import { ReactComponent as ChartIcon } from "../../../../assets/icons/Chart.svg";
import { ReactComponent as MonitorIcon } from "../../../../assets/icons/Monitor.svg";
import { ReactComponent as NotesIcon } from "../../../../assets/icons/Notes.svg";
import FCImage from "../../../../assets/images/fc.png";
import GfiImage from "../../../../assets/images/gfi.png";
import tvdImage from "../../../../assets/images/tvd.jpg";

const ManagementSolution: React.FC = () => {
  const ProcessCard: React.FC<{
    icon: React.ReactNode;
    title: string;
    description: string;
  }> = ({ icon, title, description }) => (
    <div className="hover:shadow-md transition-shadow">
      <div className="flex items-start space-x-4">
        <div className="text-yellow-600 text-xl flex-shrink-0">{icon}</div>
        <div>
          <h3 className="font-semibold text-hColor mb-2 text-sm sm:text-base">
            {title}
          </h3>
          <p className="text-gray-600 text-xs sm:text-sm">{description}</p>
        </div>
      </div>
    </div>
  );

  const VehicleTypeItem: React.FC<{
    type: string;
    count: number;
    color: string;
  }> = ({ type, count, color }) => (
    <div className="flex items-center space-x-3 mb-3">
      <div className={`w-3 h-3 rounded-full ${color}`}></div>
      <div className="flex items-center justify-between w-full">
        <span className="text-gray-600 text-sm">{type}</span>
        <span className="text-hColor font-medium text-sm">{count}</span>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen p-4 sm:p-6 py-16 sm:py-28">
      <div className="max-w-[90vw] xl:max-w-[85vw] mx-auto">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-hColor leading-tight">
            Fleet Management Solutions That Drive
          </h1>
          <h1 className="mt-3 sm:mt-6 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-hColor leading-tight">
            Business Growth
          </h1>
        </div>

        {/* Process Cards */}
        <div className="items-center justify-center border border-gray-200 rounded-lg p-4 sm:p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-8 sm:mb-12 mt-12 sm:mt-20">
          <ProcessCard
            icon={
              <div className="w-12 h-12 sm:w-[64px] sm:h-[64px] bg-[#EDF2DFB2] rounded-lg flex items-center justify-center">
                <BusIcon />
              </div>
            }
            title="Onboard your fleet"
            description="Sign up, register vehicles, add drivers"
          />
          <ProcessCard
            icon={
              <div className="w-12 h-12 sm:w-[64px] sm:h-[64px] bg-[#EDF2DFB2] rounded-lg flex items-center justify-center">
                <ChartIcon />
              </div>
            }
            title="Set up dashboard"
            description="Manage and customize dashboard"
          />
          <ProcessCard
            icon={
              <div className="w-12 h-12 sm:w-[64px] sm:h-[64px] bg-[#EDF2DFB2] rounded-lg flex items-center justify-center">
                <MonitorIcon />
              </div>
            }
            title="Monitor and optimize"
            description="Track vehicles, drivers and finances"
          />
          <ProcessCard
            icon={
              <div className="w-12 h-12 sm:w-[64px] sm:h-[64px] bg-[#EDF2DFB2] rounded-lg flex items-center justify-center">
                <NotesIcon />
              </div>
            }
            title="Generate reports"
            description="Vehicle maintenance, profit margin and more"
          />
        </div>

        {/* Main Dashboard */}
        <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between xl:space-x-10 space-y-6 xl:space-y-0">
          {/* Left Section */}
          <div className="bg-[#EDF2DFB2] rounded-[20px] px-4 sm:px-8 py-8 sm:py-20 w-full xl:w-[832px]">
            <h2 className="text-xl sm:text-2xl font-bold text-hColor mb-6 sm:mb-8">
              Take control of your fleet
            </h2>

            <div className="bg-[#F6F6F6] rounded-[20px] p-4 sm:p-12">
              <img
                src={tvdImage}
                alt="Vehicle Dashboard"
                className="w-full h-auto max-h-[200px] sm:max-h-[356px] rounded-[20px] object-cover"
              />
            </div>
          </div>

          {/* Financial Insights */}
          <div className="w-full xl:w-[832px] flex flex-col space-y-6 sm:space-y-8">
            <div className="bg-[#E7F2F5] rounded-[20px] p-6 sm:p-10">
              <img
                src={FCImage}
                alt="Fuel Cost"
                className="w-full h-auto object-contain"
              />
            </div>
            <div className="w-full">
              <img
                src={GfiImage}
                alt=""
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagementSolution;
